import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { toPlainObject } from 'lodash';

import {
    KYC_MODAL_ERROR_FAILED,
    KYC_MODAL_STEP_ERROR,
    KYC_STATE_DECLINED,
    KYC_STATE_RETRY,
    KYC_STATE_VALIDATED,
    KYC_USE_CASE_DECLINED_PURCHASE,
    KYC_USE_CASE_FAILURE_BANK_TRANSFER,
    KYC_USE_CASE_WAITING_TRANSACTION
} from '../../../services/kyc/constants';

import { hideModal } from '../../../services/modal/actions';
import { fetchKycState } from '../../../services/kyc/actions';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

const KycStep2 = ({
    i18n,
    kycWidgetLink,
    kycState,
    fetchKycState,
    hideModal,
    setStep,
    setErrorType,
    useCase
}) => {
    useEffect(() => {
        if (kycState !== null) {
            const interval = setInterval(() => {
                fetchKycState();

                if (kycState === KYC_STATE_DECLINED || kycState === KYC_STATE_RETRY) {
                    setErrorType(KYC_MODAL_ERROR_FAILED);
                    setStep(KYC_MODAL_STEP_ERROR);
                    clearInterval(interval);
                }
                if (kycState === KYC_STATE_VALIDATED) {
                    clearInterval(interval);
                    hideModal();
                }
            }, 3000);
            return () => {
                clearInterval(interval);
            };
        }
    }, [kycState]);

    return (
        <div>
            <h3 className="banner">{i18n.TITLE}</h3>
            <div className="body">
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT_1)}</p>

                {useCase === KYC_USE_CASE_DECLINED_PURCHASE ? (
                    <React.Fragment>
                        <p>{convertHtmlToReactDomWithParams(i18n.DECLINED_PURCHASE.TEXT_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.DECLINED_PURCHASE.TEXT_3)}</p>
                    </React.Fragment>
                ) : useCase === KYC_USE_CASE_FAILURE_BANK_TRANSFER ? (
                    <React.Fragment>
                        <p>{convertHtmlToReactDomWithParams(i18n.FAILURE_BANK_TRANSFER.TEXT_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.FAILURE_BANK_TRANSFER.TEXT_3)}</p>
                    </React.Fragment>
                ) : useCase === KYC_USE_CASE_WAITING_TRANSACTION ? (
                    <React.Fragment>
                        <p>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.WAITING_TRANSACTION.TEXT_3)}</p>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <p>{convertHtmlToReactDomWithParams(i18n.DEFAULT.TEXT_2)}</p>
                        <p>{convertHtmlToReactDomWithParams(i18n.DEFAULT.TEXT_3)}</p>
                    </React.Fragment>
                )}

                <p className="bold">{i18n.TEXT_4}</p>
                <p className="italic">
                    {convertHtmlToReactDomWithParams(i18n.TEXT_5, kycWidgetLink)}
                </p>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    const user = toPlainObject(state.account.user);

    return {
        i18n: state.i18n.FRAUD.KYC_MODAL.STEP_2,
        user: user,
        kycWidgetLink: state.kyc.widgetLink,
        kycState: state.kyc.state
    };
};

const mapDispatchToProps = {
    fetchKycState,
    hideModal
};

export default connect(mapStateToProps, mapDispatchToProps)(KycStep2);



// WEBPACK FOOTER //
// ./src/components/fraud/kyc/KycStep2.js